const planetes = [
    {   "name":"Prise en main",
        "questions": [
            { "code": 'gauche(1)\nbas(2)\ndroite(3)', "solution": "J10", 'type': 'carte' },
            { "code": 'gauche(%%3%%)\nhaut(%%4%%)\ndroite(%%5%%)\nbas(%%2%%)', "solution": "", 'type': 'code-trou', 'map': ["H5", 'D5', 'D10',"F10"] },
            { "code": 'a=3\nb=a*2\ndroite(a)\nbas(b)\ndroite(a/3)', "solution": "N12", 'type': 'carte' },
            { "code": 'a=3\nb=a**2\nhaut(2*a)\ngauche(5)\nbas(b)', "solution": "N3", 'type': 'carte' },
            { "code": 'a = %%4%% \nb = %%3%% \ngauche(a)\nbas(b)\ndroite(2*a)', "solution": "", 'type': 'code-trou', 'map': ["H4", 'K4', 'K12'] }, { "code": 'a = 1\nb = 2*a\nc = 2*b\ngauche(a)\nbas(b)\ndroite(c)', "solution": "J11", 'type': 'carte' },
            { "code": 'a = 2\nb = 2\na = 2*b\nb = 2*a\nhaut(a)\ndroite(b)\nbas(b)', "solution": "L12", 'type': 'carte' },
          ]
    },
    {
        "name":"FORmeon",
        "questions":[
            { "code": 'a = 1\nb = 2*a\nc = 2*b\ngauche(a)\nbas(b)\ndroite(c)', "solution": "J11", 'type': 'carte' },
            { "code": 'a = 2\nb = 2\na = 2*b\nb = 2*a\nhaut(a)\ndroite(b)\nbas(b)', "solution": "L12", 'type': 'carte' },

        ],
        disable:true
    }
]


export default planetes